type ColorMap = Record<number, string>;

export const DEFAULT_COLORS: ColorMap = {
	0: '#16213e',
	1: '#e94560',
	2: '#e67e22',
	3: '#2ecc71',
	4: '#3498db',
	5: '#9b59b6',
	6: '#c0392b',
	7: '#8b7355',
	8: '#696969',
	9: '#4b4b4d',
	10: '#2f2f2f',
};

export type {ColorMap};
